import React, { ReactNode } from "react";

import BrandPanel from "../organisms/BrandPanel";
import ThemeToggle, { ThemeProvider, useTheme } from "../molecules/ThemeToggle";

interface AuthLayoutProps {
  children: ReactNode;
}

function AuthShell({ children }: { children: ReactNode }) {
  const { isDark } = useTheme();
  return (
    <div className={isDark ? "dark" : ""}>
      <div className="bg-dotted flex min-h-screen items-center justify-center p-4">
        <div className="relative flex w-full max-w-3xl flex-col overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm dark:border-0 dark:bg-slate-800 dark:shadow-2xl dark:shadow-black/60 sm:flex-row">
          <ThemeToggle className="absolute right-3 top-3 z-10" />

          <BrandPanel />

          <main className="flex flex-1 flex-col justify-center p-8 dark:bg-slate-800 md:p-10">
            {children}

            <p className="mt-6 text-center text-xs text-gray-500 dark:text-gray-500 sm:hidden">
              © {new Date().getFullYear()} Digar LLC.
            </p>
          </main>
        </div>
      </div>
    </div>
  );
}

export default function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <ThemeProvider>
      <AuthShell>{children}</AuthShell>
    </ThemeProvider>
  );
}
